"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classes_1 = require("../classes");
exports.IOU_THRESHOLD = 0.4;
exports.BOX_ANCHORS = [
    new classes_1.Point(1.603231, 2.094468),
    new classes_1.Point(6.041143, 7.080126),
    new classes_1.Point(2.882459, 3.518061),
    new classes_1.Point(4.266906, 5.178857),
    new classes_1.Point(9.041765, 10.66308)
];
exports.MEAN_RGB = [117.001, 114.697, 97.404];
//# sourceMappingURL=const.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/face-api.js/build/commonjs/tinyFaceDetector/const.js
 ** module id = 1497
 ** module chunks = 0
 **/